<!-- Footer Section -->
<footer class="bg-[#0e3b2e] text-white">
  <div class="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8 space-y-12">

    <!-- Top grid -->
    <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-12 gap-10">

      <!-- Brand -->
      <div class="col-span-2 md:col-span-3 lg:col-span-3 space-y-5">
        <div class="flex items-center gap-3">
          <span class="flex h-11 w-11 items-center justify-center rounded-xl bg-[#e6b012] text-sm font-black text-white shadow-md">MEL</span>
          <div>
            <h4 class="text-base font-extrabold tracking-tight text-white leading-none">Gov MEL System</h4>
            <p class="mt-1 text-[10px] font-bold uppercase tracking-wider text-[#e6b012]">National Development Vision 2050</p>
          </div>
        </div>
        <p class="text-sm leading-relaxed text-white/70 max-w-xs">
          The national platform for tracking results, evidencing impact, and turning lessons into stronger public
          decisions — built for Tanzania under Vision 2050.
        </p>
        <div class="flex items-center gap-2.5">
          @for (s of socials; track s) {
            <a class="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-white/20 text-xs font-bold text-white/70 transition-colors hover:border-[#e6b012] hover:text-[#e6b012]">
              {{ s }}
            </a>
          }
        </div>
      </div>

      <!-- Link columns -->
      @for (col of linkColumns; track col.title) {
        <div class="lg:col-span-2 space-y-4">
          <h5 class="text-xs font-extrabold uppercase tracking-[0.15em] text-[#e6b012]">{{ col.title }}</h5>
          <ul class="space-y-3">
            @for (link of col.links; track link.label) {
              <li>
                <a
                  [routerLink]="link.route"
                  class="group inline-flex items-center gap-2 text-sm text-white/75 transition-colors hover:text-white cursor-pointer"
                >
                  <span class="text-[#e6b012] transition-transform group-hover:translate-x-0.5">›</span>
                  <span>{{ link.label }}</span>
                </a>
              </li>
            }
          </ul>
        </div>
      }

      <!-- Stay Updated -->
      <div class="col-span-2 md:col-span-3 lg:col-span-3 space-y-4">
        <h5 class="text-xs font-extrabold uppercase tracking-[0.15em] text-[#e6b012]">Stay Updated</h5>
        <p class="text-sm leading-relaxed text-white/70">
          Subscribe to receive MEL reports, system updates, and national development news to your inbox.
        </p>
        <div class="space-y-3">
          <input
            type="email"
            placeholder="Enter your email address"
            class="w-full h-11 rounded-lg bg-white px-4 text-sm text-slate-700 placeholder-slate-400 outline-none focus:ring-2 focus:ring-[#e6b012]/40"
          />
          <input
            type="text"
            placeholder="Institution / Ministry name"
            class="w-full h-11 rounded-lg bg-white px-4 text-sm text-slate-700 placeholder-slate-400 outline-none focus:ring-2 focus:ring-[#e6b012]/40"
          />
          <button
            type="button"
            class="w-full h-11 rounded-lg bg-[#e6b012] text-sm font-extrabold text-white transition-all hover:bg-[#d4a00e] active:scale-[0.99]"
          >
            Subscribe to Updates
          </button>
        </div>
      </div>
    </div>

    <!-- Contact band -->
    <div class="rounded-2xl border border-white/10 p-6 lg:p-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
      @for (c of contacts; track c.label) {
        <div class="flex items-start gap-3">
          <span class="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg bg-white/5 text-[#e6b012]">
            <mat-icon class="!text-xl">{{ c.icon }}</mat-icon>
          </span>
          <div class="min-w-0">
            <p class="text-[10px] font-extrabold uppercase tracking-wider text-[#e6b012]">{{ c.label }}</p>
            @if (c.href) {
              <a [href]="c.href" target="_blank" rel="noopener" class="mt-1 block text-sm text-white/85 leading-snug transition-colors hover:text-[#e6b012] break-words">{{ c.value }}</a>
            } @else {
              <p class="mt-1 text-sm text-white/85 leading-snug">{{ c.value }}</p>
            }
          </div>
        </div>
      }
    </div>

    <!-- Bottom row -->
    <div class="pt-8 border-t border-white/10 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between text-sm text-white/60">
      <p>© {{ currentYear }} Government of the United Republic of Tanzania. All rights reserved. MEL System v2.4.1</p>
      <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
        @for (l of legalLinks; track l.label) {
          <a [routerLink]="l.route" class="cursor-pointer transition-colors hover:text-white">{{ l.label }}</a>
        }
      </div>
    </div>
  </div>

  <!-- Accent strip -->
  <div class="flex h-1.5">
    <div class="flex-1 bg-[#1e8449]"></div>
    <div class="flex-1 bg-[#e6b012]"></div>
    <div class="flex-1 bg-black"></div>
    <div class="flex-1 bg-[#3498db]"></div>
  </div>
</footer>
